import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '../../../common/StyledTypography';
import Button from 'apollo-react/components/Button';
import PlusIcon from 'apollo-react-icons/Plus';
import PlusCircle from 'apollo-react-icons/PlusCircle';
import ThumbsUpFilled from 'apollo-react-icons/ThumbsUpFilled';
import Close from 'apollo-react-icons/Close';
import Redo from 'apollo-react-icons/Redo';
import Paper from 'apollo-react/components/Paper';
import styles from './BuilderSidebar.module.css';
import {
  APPROVAL_TYPE_IDS,
  APPROVAL_TYPE_CODES,
} from '../../../../constants/workflow.constant';

const Sidebar = () => {
  const { t } = useTranslation();

  const onDragStart = useCallback((event, type, data) => {
    event.dataTransfer.setData('application/reactflow', type);
    event.dataTransfer.setData('data', JSON.stringify(data || {}));
    event.dataTransfer.effectAllowed = 'move';
  }, []);

  return (
    <Paper className={styles.paper}>
      <Typography variant="bodySmall" className={styles.verticalMargin}>
        {t('workflowBuilder.dragNodesHint')}
      </Typography>
      <Typography
        className={styles.typography}
        variant="subtitle"
        gutterBottom
        emphasis="high"
      >
        {t('workflowBuilder.createNewFlow')}
      </Typography>

      <div className={styles.sidebar_buttons_div}>
        <Button
          className={styles.buttons}
          variant="secondary"
          disabled
          icon={PlusIcon}
        >
          {t('workflowBuilder.startFlow')}
        </Button>
      </div>

      <div className={styles.sidebar_buttons_div}>
        <Button
          className={styles.buttons}
          onDragStart={(event) => onDragStart(event, 'output')}
          draggable
          variant="secondary"
          icon={PlusIcon}
        >
          {t('workflowBuilder.endFlow')}
        </Button>
      </div>

      <Typography
        className={styles.typography}
        variant="subtitle"
        gutterBottom
        emphasis="high"
      >
        {t('workflowBuilder.stages')}
      </Typography>

      <div className={styles.sidebar_buttons_div}>
        <Button
          className={styles.buttons}
          onDragStart={(event) => onDragStart(event, 'FormStage')}
          draggable
          variant="secondary"
          icon={PlusCircle}
        >
          {t('workflowBuilder.addStage')}
        </Button>
      </div>

      <Typography
        className={styles.typography}
        variant="subtitle"
        gutterBottom
        emphasis="high"
      >
        {t('workflowBuilder.actions')}
      </Typography>

      <div className={styles.sidebar_buttons_div}>
        <Button
          className={styles.actionButtons}
          onDragStart={(event) =>
            onDragStart(event, `approval-${APPROVAL_TYPE_IDS.APPROVED}`, {
              approvalTypeId: APPROVAL_TYPE_IDS.APPROVED,
              code: APPROVAL_TYPE_CODES.APPROVED,
              name: t('workflowBuilder.approve'),
            })
          }
          draggable
          variant="secondary"
          icon={ThumbsUpFilled}
        >
          {t('workflowBuilder.approve')}
        </Button>
      </div>

      <div className={styles.sidebar_buttons_div}>
        <Button
          className={styles.actionButtons}
          onDragStart={(event) =>
            onDragStart(event, `approval-${APPROVAL_TYPE_IDS.REJECTED}`, {
              approvalTypeId: APPROVAL_TYPE_IDS.REJECTED,
              code: APPROVAL_TYPE_CODES.REJECTED,
              name: t('workflowBuilder.reject'),
            })
          }
          draggable
          variant="secondary"
          icon={Close}
        >
          {t('workflowBuilder.reject')}
        </Button>
      </div>

      <div className={styles.sidebar_buttons_div}>
        <Button
          className={styles.actionButtons}
          onDragStart={(event) =>
            onDragStart(event, `approval-${APPROVAL_TYPE_IDS.SEND_BACK}`, {
              approvalTypeId: APPROVAL_TYPE_IDS.SEND_BACK,
              code: APPROVAL_TYPE_CODES.SEND_BACK,
              name: t('workflowBuilder.sendBack'),
            })
          }
          draggable
          variant="secondary"
          icon={Redo}
        >
          {t('workflowBuilder.sendBack')}
        </Button>
      </div>

      <div className={styles.sidebar_buttons_div}>
        <Button
          className={styles.actionButtons}
          onDragStart={(event) =>
            onDragStart(
              event,
              `approval-${APPROVAL_TYPE_IDS.SEND_TO_ASSESSMENT}`,
              {
                approvalTypeId: APPROVAL_TYPE_IDS.SEND_TO_ASSESSMENT,
                code: APPROVAL_TYPE_CODES.SEND_TO_ASSESSMENT,
                name: t('workflowBuilder.sendToAssessment'),
              }
            )
          }
          draggable
          variant="secondary"
          icon={Redo}
        >
          {t('workflowBuilder.sendToAssessment')}
        </Button>
      </div>
    </Paper>
  );
};

export default Sidebar;
